import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function DislikeIcon(rest) {
  return (
    <Icon {...rest}>
      <path d="M43.6777 29.6957H33.9692V39.2794C33.9692 41.0745 32.5021 42.5295 30.6921 42.5295C29.6973 42.5295 28.7543 42.0804 28.1331 41.3103L16.1763 26.4872H16.1779H16.1763V10.4449L21.0289 7.23638H41.2045C42.6473 7.23638 43.9154 8.18609 44.3117 9.56413L48.3394 23.5611C49.2226 26.6348 46.8982 29.6957 43.6777 29.6957Z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9884 42.2335C27.8906 43.352 29.2555 44 30.6919 44C33.3026 44 35.4396 41.898 35.4396 39.2793V31.1661H43.6775C47.8622 31.1661 50.9096 27.1816 49.7526 23.1549L45.7249 9.15761C45.7248 9.15753 45.7249 9.15768 45.7249 9.15761C45.1456 7.14374 43.2966 5.76574 41.2043 5.76574H21.0287C20.7403 5.76574 20.4583 5.85055 20.2177 6.00962L15.3651 9.21809C14.9533 9.49036 14.7056 9.95109 14.7056 10.4448V26.4871C14.7056 26.8409 14.8305 27.1655 15.0387 27.4192L26.9884 42.2335ZM17.6467 25.9679V11.2354L21.4709 8.70684H41.2043C41.9976 8.70684 42.6849 9.22838 42.8983 9.97046L46.9259 23.9671C47.5352 26.0878 45.9338 28.225 43.6775 28.225H33.969C33.1569 28.225 32.4985 28.8834 32.4985 29.6956V39.2793C32.4985 40.2508 31.7013 41.0589 30.6919 41.0589C30.1387 41.0589 29.6176 40.8085 29.2776 40.387L17.6467 25.9679Z"
      />
      <path d="M10.294 27.824H1.4707V7.2363H10.294V27.824Z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 27.8239C0 28.636 0.658387 29.2944 1.47055 29.2944H10.2938C11.106 29.2944 11.7644 28.636 11.7644 27.8239V7.23621C11.7644 6.42405 11.106 5.76566 10.2938 5.76566H1.47055C0.658387 5.76566 0 6.42405 0 7.23621V27.8239ZM2.9411 26.3533V8.70676H8.82329V26.3533H2.9411Z"
      />
    </Icon>
  );
}
